import type { SVGProps } from 'react';

const SvgPlayerViewFull = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M20.92 3.62A1.02 1.02 0 0 0 20 3h-4c-.55 0-1 .45-1 1s.45 1 1 1h1.59L15.3 7.29a.996.996 0 0 0 .71 1.7c.26 0 .51-.1.71-.29l2.29-2.29V8c0 .55.45 1 1 1s1-.45 1-1V4c0-.13-.03-.26-.08-.38zM8.71 15.29a.996.996 0 0 0-1.41 0l-2.29 2.29v-1.59c0-.55-.45-1-1-1s-1 .45-1 1v4a1.02 1.02 0 0 0 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1H6.42l2.29-2.29a.996.996 0 0 0 0-1.41M20 15c-.55 0-1 .45-1 1v1.59l-2.29-2.29a.996.996 0 1 0-1.41 1.41L17.59 19H16c-.55 0-1 .45-1 1s.45 1 1 1h4a1.02 1.02 0 0 0 1-1v-4c0-.55-.45-1-1-1M9 4c0-.55-.45-1-1-1H4c-.13 0-.26.03-.38.08-.25.1-.44.29-.54.54-.05.12-.08.25-.08.38v4c0 .55.45 1 1 1s1-.45 1-1V6.41L7.29 8.7c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41L6.42 5h1.59c.55 0 1-.45 1-1z"
    />
  </svg>
);
export default SvgPlayerViewFull;
